/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleUpgradeChangeSummaryAddedByType } from './moduleUpgradeChangeSummaryAddedByType';
import type { ModuleUpgradeChangeSummaryRemovedByType } from './moduleUpgradeChangeSummaryRemovedByType';
import type { ModuleUpgradeChangeSummaryAiTutorGainedByType } from './moduleUpgradeChangeSummaryAiTutorGainedByType';
import type { ModuleUpgradeChangeSummaryGradeBasisBeforeByType } from './moduleUpgradeChangeSummaryGradeBasisBeforeByType';
import type { ModuleUpgradeChangeSummaryGradeBasisAfterByType } from './moduleUpgradeChangeSummaryGradeBasisAfterByType';

/**
 * Derived task-type counts for a module upgrade offer (no task titles).
 */
export interface ModuleUpgradeChangeSummary {
  addedByType?: ModuleUpgradeChangeSummaryAddedByType;
  removedByType?: ModuleUpgradeChangeSummaryRemovedByType;
  aiTutorGainedByType?: ModuleUpgradeChangeSummaryAiTutorGainedByType;
  gradeBasisBeforeByType?: ModuleUpgradeChangeSummaryGradeBasisBeforeByType;
  gradeBasisAfterByType?: ModuleUpgradeChangeSummaryGradeBasisAfterByType;
  removedWithProgress?: number;
  gradeBecomesOralOnly?: boolean;
  hasFinishedWorkThatStopsCounting?: boolean;
}
